export enum SubscriptionStatus {
    TRIAL = 'trial',
    TRIAL_GRACE = 'trial_grace',
    CANCELLED = 'cancelled',
    CANCELLING = 'cancelling',
    ACTIVE = 'active'
};
